export interface GDPRSettings {
	enable_cookie_banner?: boolean;
}

export const COOKIES_ACCEPTED_INDEX_DB = 'COOKIES_ACCEPTED';
